/**
 * View component for a single content module's evaluations
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as evaluationActions from '../evaluationActions.js';
import * as contentModuleActions from '../../contentModule/contentModuleActions.js';

// import global components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import evaluation components
import AdminCmEvaluationListItem from '../components/AdminCmEvaluationListItem.js.jsx';

class AdminCmEvaluationList extends Base {
  constructor(props) {
    super(props);
    this.state = {
      perPage: 50
      , queryText: this.props.query || ''
    };
    this._bind(
      '_handleCreateEvaluation'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    // fetch a list of your choice
    dispatch(contentModuleActions.fetchSingleIfNeeded(match.params.contentModuleId));
    dispatch(evaluationActions.fetchListIfNeeded('_contentModule', match.params.contentModuleId)); // defaults to 'all'
  }

  _handleCreateEvaluation() {
    const { dispatch, evaluationStore, match, contentModuleStore } = this.props;
    const evaluations = evaluationStore.util.getList('_contentModule', match.params.contentModuleId);
    const selectedContentModule = contentModuleStore.selected.getItem();
    let newEvaluation = _.cloneDeep(evaluationStore.defaultItem);
    newEvaluation._contentModule = match.params.contentModuleId;
    newEvaluation.title = 'Exam #'+(evaluations.length + 1)+' for ' + selectedContentModule.title;
    dispatch(evaluationActions.sendCreateEvaluation(newEvaluation)).then(action => {
      dispatch(evaluationActions.fetchList('_contentModule', match.params.contentModuleId));
    })
  }

  render() {
    const {
      evaluationStore
      , location
      , match
      , contentModuleStore
    } = this.props;

    const contentModule = contentModuleStore.selected.getItem(); 
    const evaluationList = evaluationStore.util.getList('_contentModule', match.params.contentModuleId); 
    const evaluationListInfo = evaluationStore.lists && evaluationStore.lists['_contentModule'] && evaluationStore.lists['_contentModule'][match.params.contentModuleId]
    const isEmpty = !contentModule || !evaluationList || !evaluationListInfo || !evaluationListInfo.items || evaluationListInfo.didInvalidate;

    return (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              { isEmpty ?
                  (
                    evaluationListInfo && evaluationListInfo.isFetching ?
                      <div className="u-centerText">
                        <div className="loading"></div>
                      </div>
                    :
                      <h2>Empty.</h2>
                  )
                :
                  <div style={{ opacity: evaluationList.isFetching ? 0.5 : 1 }}>
                    <div className="breadcrumbs">
                      <span>
                        <a href={`${window.authoringUrl}/content-modules/${match.params.contentModuleId}`}>Module Details / </a>
                        Evaluations
                      </span>
                    </div>
                    <h1> {contentModule.title} </h1>
                    <div style={{paddingBottom: '20px'}}>
                    <h3>
                      Evaluations
                      <button className="yt-btn u-pullRight" disabled={!contentModule.testable} onClick={this._handleCreateEvaluation}>Create New Evaluation</button>
                    </h3>
                    </div>
                    {evaluationList && evaluationList.length > 0 ?
                      <div className="content-container">
                        <div className="table-wrapper">
                          <table className="yt-table striped">
                            <thead>
                              <tr>
                                <th className="_40 sortable">
                                  Title
                                </th>
                                <th className="_20 sortable">
                                  Status
                                </th>
                                <th className="_20 sortable">
                                  Last Modified
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                evaluationList.map((evaluation, i) =>
                                <AdminCmEvaluationListItem
                                  evaluation={evaluation}
                                  key={evaluation._id}
                                  />
                                )
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    : 
                      <div className="content-container">
                        <p>No evaluations exist for this module yet. {!contentModule.testable ? "The module must be 'testable' in order to create new evaluations." : null}</p>
                      </div>
                    }
                  </div>
              }
            </div>
          </section>
        </div>
      </AuthoringLayout>
    )
  }
}

AdminCmEvaluationList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  
  return {
    evaluationStore: store.evaluation
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminCmEvaluationList)
);



// WEBPACK FOOTER //
// modules/evaluation/views/AdminCmEvaluationList.js.jsx